export default __webpack_public_path__ + "static/media/mp4.d4a14778.svg";